import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatOrganization } from '../models/organization.model';

// Lists every clinic in the system -- used exclusively to populate `CommunicationPage`'s
// Developer-only clinic picker, gated server-side to SuperAdmin/Developer (`GET /api/organizations`).
export interface IOrganizationsRepository {
  list(): Observable<readonly ChatOrganization[]>;
}

export const ORGANIZATIONS_REPOSITORY = new InjectionToken<IOrganizationsRepository>('IOrganizationsRepository');
